import '@babel/polyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {Navbar} from 'bootstrap-vue/es/components'
import jwt_decode from 'jwt-decode'
import {library} from '@fortawesome/fontawesome-svg-core'
import {
    faCoffee, faVolumeMute, faEyeSlash, faEdit, faList, faInfo, faBackward,
    faAngleRight, faAngleLeft, faAngleDoubleRight, faAngleDoubleLeft, faDownload
}
from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

//Loading font awesome stuff:
library.add(faCoffee)
library.add(faVolumeMute)
library.add(faEyeSlash)
library.add(faEdit)
library.add(faList)
library.add(faInfo)
library.add(faBackward)
library.add(faAngleLeft)
library.add(faAngleRight)
library.add(faAngleDoubleLeft)
library.add(faAngleDoubleRight)
library.add(faDownload)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(Navbar)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

//Retrieve user and token (even if its null) and commit to store:
store.commit('setUser', JSON.parse(localStorage.getItem('user')))
store.commit('setToken', localStorage.getItem('token'))

// Some middleware to help us ensure the user is authenticated, applied for each navigation
// over the router.
router.beforeEach((to, from, next) => {
    if (to.path === '/login') {
        next()
    }

    if (!router.app.$store.state.token || router.app.$store.state.token === 'null') {
        window.console.log('Not authenticated')
        next({
            path: '/login'
        })
    }

    let expires = jwt_decode(router.app.$store.state.token).exp
    let current = Math.ceil((new Date().getTime()) / 1000)
    if (current >= expires) {
        next({
            path: '/login'
        })
    }

    next()
})

Vue.prototype.$eventBus = new Vue()

//Instance the Vue!
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
